import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";
import { PickList } from 'primereact/picklist';

import ConfigsService from '../../service/ConfigsService';

const configService = new ConfigsService(); // Create an instance of PrestadorService

const CadastrarPerfilAcesso = () => {
    const iss = localStorage.getItem('iss');
    const idUser = localStorage.getItem('idUser');
    const history = useHistory();

    let perfilNovo = {
        id: null,
        name: null,
        description: null,
        permissions: []
    };


    const [perfil, setPerfil] = useState(perfilNovo);
    const [picklistSource, setPicklistSource] = useState(false);
    const [picklistSourcePermissions, setPicklistSourcePermissions] = useState([]);
    const [picklistTargetPermissions, setPicklistTargetPermissions] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const { id } = useParams();

    useEffect(() => {
        initPermissions();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const initPermissions = () => {
        setLoading(true);
        configService.listAllPermissions(iss).then(data => {
            setPicklistSourcePermissions(data.data.rows);
            setPicklistSource(true)
            setLoading(false);
        });
    }

    useEffect(() => {

        if (id != null) {
            setLoading(true);
            configService.getRole(iss, id).then(data => {
                setLoading(false);
                perfilNovo = data.data;
                const diff1 = picklistSourcePermissions.filter(obj1 => {
                    return !perfilNovo.permissions.some(obj2 => obj2['id'] === obj1['id']);
                });
                setTimeout(() => {
                    setPicklistTargetPermissions(perfilNovo.permissions)
                    setPicklistSourcePermissions(diff1);
                    setPerfil(perfilNovo);
                }, 200);

            });
        }
    }, [picklistSource]); //

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';

        if (checkbox) {
            val = e.checked;
        }

        let _perfil = { ...perfil };
        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_perfil[parent]) {
                _perfil[parent] = {}; // Cria o objeto pai se não existir
            }
            _perfil[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _perfil[name] = val;
            } else {
                _perfil[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }

        setPerfil(_perfil);

    }

    const cadastrar = () => {
        setSubmitted(true);
        if (perfil.name && perfil.description) {
            let { id, permissions, ..._perfil } = perfil;
            if (id == null) {

                setLoading(true)
                configService.postRole(iss, _perfil).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de perfil', detail: 'Perfil de acesso cadastrado com sucesso' });
                    history.push('/roles/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            } else {
                setLoading(true)
                perfil.permissions = picklistTargetPermissions.map(p => p.id);

                configService.putRole(iss, perfil, id).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de perfil', detail: 'Perfil de acesso editado com sucesso' });
                    history.push('/roles/listar');
                    return;
                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }
        }
    }

    return (
        <div className="grid">
            <h4>Informações do Perfil</h4>
            <div className="col-12">
                <div className="card">
                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <InputText value={perfil.name} onChange={(e) => onInputChange(e, 'name')}
                                    className={classNames({ 'p-invalid': submitted && !perfil.name })} required id="name" type="text"
                                />
                                <label htmlFor="name">Nome</label>
                            </span>
                            {submitted && !perfil.name && <small className="p-invalid">Nome é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-10">
                            <span className="p-float-label">
                                <InputText value={perfil.description} onChange={(e) => onInputChange(e, 'description')}
                                    className={classNames({ 'p-invalid': submitted && !perfil.name })} required id="description" type="text"
                                />
                                <label htmlFor="description">Descrição</label>
                            </span>
                            {submitted && !perfil.description && <small className="p-invalid">Descrição é obrigatório.</small>}
                        </div>
                        <div className="col-12 lg:col-12">
                            <div className="card">
                                <h5>Lista de Permissões</h5>
                                <PickList source={picklistSourcePermissions} target={picklistTargetPermissions} sourceHeader="Permissões" targetHeader="Selecionadas" itemTemplate={(item) => <div>{item.name}</div>}
                                    onChange={(e) => { setPicklistSourcePermissions(e.source); setPicklistTargetPermissions(e.target) }} sourceStyle={{ height: '200px' }} targetStyle={{ height: '200px' }}></PickList>
                            </div>
                        </div>

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarPerfilAcesso, comparisonFn);
